import styled from "styled-components";
import { ThemeType } from "../../types/Theme";
import { CardAula } from "./AulaCard/styles";

// ---- Vitrine ----
export const ContainerVitrine = styled.div<{ theme: ThemeType }>`
  padding: 4rem 4rem 8rem;
  color: ${({ theme }) => theme.colors.tertiary};

  /* banner do clube — mesma proporção/estilo do banner da trilha (1098 x 152) */
  .banner-clube {
    max-width: 1098px;
    margin: 0 auto;
    .capa {
      display: block;
      width: 100%;
      aspect-ratio: 1098 / 152;
      height: auto;
      object-fit: cover;
      border-radius: 4rem;
    }
  }

  /* mesma coluna de 1098px do banner, pra alinhar tudo */
  .trilha-secao {
    max-width: 1098px;
    margin: 6rem auto 0;
    .secao-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2.5rem;
      strong {
        color: ${({ theme }) => theme.colors.secondary};
      }
      .ver-trilha {
        cursor: pointer;
        color: ${({ theme }) => theme.colors.secondary};
        white-space: nowrap;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .linha-aulas {
      display: flex;
      gap: 2.5rem;
      padding-bottom: 1.5rem;
      /* esconde o scroll; aparece suave (fade) com o mouse em cima */
      scrollbar-color: transparent transparent;
      transition: scrollbar-color 0.3s ease;
      &::-webkit-scrollbar-thumb {
        background-color: transparent;
        transition: background-color 0.3s ease;
      }
      &:hover {
        scrollbar-color: ${({ theme }) => theme.colors.elements} transparent;
        &::-webkit-scrollbar-thumb {
          background-color: ${({ theme }) => theme.colors.elements};
        }
      }
      ${CardAula} {
        width: 40rem;
        height: 23rem;
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 3rem 3rem 10rem;
    .trilha-secao .linha-aulas ${CardAula} {
      width: 36rem;
      height: 22rem;
    }
  }

  /* mobile: banner mais alto (variação 1098 x 302) */
  @media (max-width: 425px) {
    .banner-clube .capa {
      aspect-ratio: 1098 / 302;
    }
  }
`;
